
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { InfoIcon } from 'lucide-react';

interface CardStatsProps {
  agreePercentage: number;
  onAgreePercentageChange: (value: number) => void;
  totalPollsters: number;
  onTotalPollstersChange: (value: number) => void;
  isReadOnly?: boolean;
}

const CardStats: React.FC<CardStatsProps> = ({
  agreePercentage,
  onAgreePercentageChange,
  totalPollsters,
  onTotalPollstersChange,
  isReadOnly = false
}) => {
  return (
    <div className="space-y-4">
      {isReadOnly && (
        <div className="flex items-center text-sm text-amber-600 dark:text-amber-400 mb-2">
          <InfoIcon size={16} className="mr-2" />
          <span>These statistics are calculated automatically from linked polls. Edit manually only if necessary.</span>
        </div>
      )}
      
      <div className="grid grid-cols-2 gap-4">
        <div className="grid gap-2">
          <Label htmlFor="agreePercentage">Agreement Percentage</Label>
          <div className="flex items-center space-x-2">
            <Input
              id="agreePercentage"
              type="number"
              min="0"
              max="100"
              value={agreePercentage || 0}
              onChange={(e) => onAgreePercentageChange(
                Math.min(100, Math.max(0, parseInt(e.target.value) || 0))
              )}
              className={`${isReadOnly ? "bg-muted dark:bg-muted" : "bg-background dark:bg-background"}`}
              readOnly={isReadOnly}
            />
            <span className="text-sm">%</span>
          </div>
        </div>
        
        <div className="grid gap-2">
          <Label htmlFor="totalPollsters">Total Responses</Label>
          <Input
            id="totalPollsters"
            type="number"
            min="0"
            value={totalPollsters || 0}
            onChange={(e) => onTotalPollstersChange(
              Math.max(0, parseInt(e.target.value) || 0)
            )}
            className={`${isReadOnly ? "bg-muted dark:bg-muted" : "bg-background dark:bg-background"}`}
            readOnly={isReadOnly}
          />
        </div>
      </div>
    </div>
  );
};

export default CardStats;
